
import { defineComponent, ref } from 'vue'
import { mapState, mapActions } from 'vuex'
import Sidebar from '@/assets/components/Sidebar.vue'
import Header from '@/assets/components/Header.vue'
import Footer from '@/assets/components/Footer.vue'

import HomeInfo from '@/assets/components/HomeInfo.vue'
import HomeContent from '@/views/home/content/index.vue'
import DataTableINeedToSign from '@/views/home/dataTable/dataTableINeedToSign.vue'
import DataTableOthersPendingSign from '@/views/home/dataTable/dataTableOthersPendingSign.vue'
import HeaderContent from '@/views/home/headerContent/index.vue'
import FooterContent from '@/views/home/footerContent/index.vue'
import { TokenService } from '@/services/TokenService'
import { ListEnvelope } from '@/services/responses/ListEnvelopeResponse'
import { AccountService } from '@/services/AccountService'
import { UserService } from '@/services/UserService'
import {
  FileTextOutlined,
  EyeOutlined
} from '@ant-design/icons-vue'

export default defineComponent({
  name: 'MainPage',
  components: {
    Sidebar,
    Header,
    Footer,
    HomeInfo,
    HomeContent,
    DataTableINeedToSign,
    DataTableOthersPendingSign,
    HeaderContent,
    FooterContent,
    FileTextOutlined,
    EyeOutlined
  },
  data: () => ({
    visible: ref<boolean>(false),
    serviceAccount: ref<AccountService>(),
    serviceUser: ref<UserService>(),
    isMobile: ref<boolean>(false),
    userData: ref<any>(null),
    envelopesConsummation: ref<number>(0),
    envelopesLimit: ref<number>(0),
    whatsappConsummation: ref<number>(0),
    whatsappLimit: ref<number>(0),
    isActionAdminOrSysAdmin: ref<boolean>(false),
    isExceededLimitEnvelope: ref<boolean>(false)
  }),
  watch: {
    openNewDocument () {
      this.visible = this.openNewDocument
    }
  },
  computed: {
    ...mapState('authenticator', ['email']),
    ...mapState('authenticator', ['logo']),
    ...mapState('sections', [
        'openNewDocument',
        'envelopes',
        'envelopesINeedToSign',
        'envelopesOthersPendingSign',
        'isHome',
        'treeSelected',
        'pagePagination',
        'currentStatus'
    ]),

    hasEnvelope (): boolean {
      return this.envelopes?.data.length > 0
    },
    envelops (): ListEnvelope[] {
      return this.envelopes !== null ? this.envelopes?.data : []
    },
    envelopsINeedToSign (): ListEnvelope[] {
      return this.envelopesINeedToSign !== null ? this.envelopesINeedToSign?.data : []
    },
    envelopsOthersPendingSign (): ListEnvelope[] {
      return this.envelopesOthersPendingSign !== null ? this.envelopesOthersPendingSign?.data : []
    }
  },
  async mounted () {
    this.serviceAccount = AccountService.getInstance()
    this.serviceUser = UserService.getInstance()

    const userDataByToken = TokenService.getUserData()

    this.userData = await this.serviceUser.getDataUserById(userDataByToken.userId)
    const typeAccount = this.userData.userAccounts[0].type
    const isSysAdmin = this.userData.isSysAdmin
    if (typeAccount === 2 || isSysAdmin) this.isActionAdminOrSysAdmin = true

    if (window.innerWidth < 768) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  methods: {
    ...mapActions('sections', [
      'fetchEnvelops',
      'setOpenNewDocument',
      'setHomePage',
      'fetchEnvelopesByUser',
      'setTreeSelected',
      'setStatusList',
      'setCurrentStatus',
      'setPagePagination',
      'setFolderId',
      'setFolderName'
    ]),
    getEmail (): string {
      const userData = TokenService.getUserData()
      return userData.userEmail
    },
    newDocument () {
      this.$router.push({
        name: 'novoDocumento'
      })
    },
    async getEnvelopesByStatus (status: number) {
      this.setHomePage(false)
      this.setCurrentStatus(status)
      this.setTreeSelected(['0'])
      const page = this.pagePagination !== undefined ? this.pagePagination : 1
      this.setStatusList(status)
      await this.fetchEnvelopesByUser({ page: page, size: null, status: status, filtered: null })
    },
    handleHomeInfoUpdate (data: any) {
      this.envelopesConsummation = data.envelopesConsummation
      this.envelopesLimit = data.envelopesLimit
    }
  }
})
